import Fade from '@mui/material/Fade';
import React, { FC } from 'react';
import BoxModalStyled from '../styled';
import CreateIndicator from './createIndicator';
import { DashboardModalProps } from './dashboardModalInterface';
import { CloseIconModalStyled, ModalStyled } from './styled';

const DashboardModal: FC<DashboardModalProps> = ({ defaultView, editIndicator, editQuestion, editCrossingQuestion, openModal, setOpenModal, isEdit, rankingParameter }) => {
    const handleClose = () => {
        setOpenModal(false);
    };

    return (
        <ModalStyled
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            onClose={handleClose}
            open={openModal}
        >
            <Fade in={openModal}>
                <BoxModalStyled>
                    <CloseIconModalStyled onClick={handleClose} />
                    <CreateIndicator defaultView={defaultView} editCrossingQuestion={editCrossingQuestion} editIndicator={editIndicator} editQuestion={editQuestion} isEdit={isEdit} rankingParameter={rankingParameter} setOpenModal={setOpenModal} />
                </BoxModalStyled>
            </Fade>
        </ModalStyled>
    );
};

export default DashboardModal;
